import styled from 'styled-components';

export const NoCarsWrapper = styled.div`
    border-radius: 1.2rem;
    background-color: #ffffff;
    padding: 5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: ${p => p.margin ? p.margin : ''};
    h4{
        font-size: 1.6rem;
        color: #2276e3;
        font-weight: 600;
        margin: 2.5rem 0 0.8rem 0;
    }
    p{
        font-size: 1.4rem;
        line-height: 1.8rem;
        color: #4f525a;
        margin: 0 0 4rem 0;
    }
`;